import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListSearchSharedListPayload } from '@app-store/slices/sharedLists/listSearch'

interface TaskAction extends Action {
    payload: IListSearchSharedListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.listSearch

function* listSearchSharedListSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/shared-lists`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result.data)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onFailure) payload.sagaCB.onError(error)
    }
}

function* listSearchSharedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSearchSharedListSagaTask)
}

export default listSearchSharedListSaga
